// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ImagensServicos_DeletarFotoAjaxResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/imagens_servicos/deletar_foto_ajax/{imagem_id}
 *
 * Returns null `dados` on success — legacy shape emitted only success +
 * a human-readable message; the message is consumed by the frontend via
 * the standard error envelope on failure, so success carries no payload.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ImagensServicos_DeletarFotoAjaxResponseDados = null;

export type ImagensServicos_DeletarFotoAjaxResponse = ApiResponse<ImagensServicos_DeletarFotoAjaxResponseDados>;

registerResponseContract('ImagensServicos_DeletarFotoAjaxResponse', {})
